/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, Ref, useEffect, useRef, useState } from 'react';
import { Box, Step, Text } from '@components/design-system';
import * as Styles from './styles';

interface INewsletter {
  placeholder: string;
  cta: string;
}

enum STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export const Newsletter: FC<INewsletter> = ({ placeholder, cta }) => {
  const domElement: Ref<any> = useRef<HTMLInputElement>();
  const [status, setStatus] = useState(STATUS.IDLE);
  const [message, setMessage] = useState<string | null | undefined>();
  const timer = useRef(0);

  const resetForm = () => {
    clearTimeout(timer.current);

    timer.current = window.setTimeout(() => {
      setStatus(STATUS.IDLE);
      setMessage(null);
      domElement.current.value = '';
    }, 3000);
  };

  const subscribeNewsletter = async (e: any) => {
    e.preventDefault();

    setStatus(STATUS.LOADING);
    setMessage(null);

    try {
      const response = await fetch('/api/subscription/mailing', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: domElement.current.value,
        }),
      });

      if (response.status !== 201) {
        const { error } = await response.json();
        setStatus(STATUS.ERROR);
        setMessage(error);
        resetForm();
      } else {
        setStatus(STATUS.SUCCESS);
        setMessage('Email added sucessfully');
        resetForm();
      }
    } catch (error: any) {
      setStatus(STATUS.ERROR);
      setMessage(error);
      resetForm();
    }
  };

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  return (
    <>
      <Styles.Form onSubmit={subscribeNewsletter}>
        <input
          id="newsletter"
          ref={domElement}
          type="email"
          placeholder={placeholder}
          required
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
        />
        {status === STATUS.LOADING ? (
          <Styles.ButtonHolder>
            <Step progress />
          </Styles.ButtonHolder>
        ) : (
          <Box as="button" type="submit" vertical horizontal>
            <strong>{cta}</strong>
          </Box>
        )}
      </Styles.Form>
      <Box>
        {status === STATUS.SUCCESS && (
          <Text css={{ color: '$secondaryFill', fontSize: 13, padding: '$space$5 $space$4' }}>{message}</Text>
        )}
        {status === STATUS.ERROR && (
          <Text css={{ color: '$red', fontSize: 13, padding: '$space$5 $space$4' }}>{message}</Text>
        )}
      </Box>
    </>
  );
};
